export default __webpack_public_path__ + "static/media/Aura-Egg__05.8119490a.png";